import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import axios from 'axios';

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AdminRoute from "./components/AdminRoute";

// SEO Components
import SEOHead from "./components/SEOHead";
import ServiceSchema from "./components/ServiceSchema";
import ReviewSchema from "./components/ReviewSchema";
import PerformanceOptimizations from "./components/PerformanceOptimizations";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const contactRef = useRef(null);
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  const scrollToContact = () => {
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      contactElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Fetch data for schema components
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, testimonialsRes] = await Promise.all([
          axios.get(`${BACKEND_URL}/api/services`),
          axios.get(`${BACKEND_URL}/api/testimonials`)
        ]);
        setServices(servicesRes.data);
        setTestimonials(testimonialsRes.data);
      } catch (error) {
        console.error('Error fetching data for SEO:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen">
      {/* Performance Optimizations */}
      <PerformanceOptimizations />
      
      {/* SEO Head Tags */}
      <SEOHead />
      
      {/* Header */}
      <Header onGetInTouchClick={scrollToContact} />
      
      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <HeroSection onGetInTouchClick={scrollToContact} />
        
        {/* Services Section */}
        <ServicesSection onGetInTouchClick={scrollToContact} />
        
        {/* Testimonials Section */}
        <TestimonialsSection />
        
        {/* Contact Section */}
        <ContactSection ref={contactRef} />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Scroll to Top Button */}
      <ScrollToTop />
      
      {/* Schema Markup Components */}
      <ServiceSchema services={services} />
      <ReviewSchema testimonials={testimonials} />
      
      {/* Toast Notifications */}
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminRoute />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;